module.exports = __webpack_public_path__ + "img/veselo.b4c9e3b4.png";